import * as React from 'react';
import React__default from 'react';

function unwrapExports (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, basedir, module) {
	return module = {
	  path: basedir,
	  exports: {},
	  require: function (path, base) {
      return commonjsRequire(path, (base === undefined || base === null) ? module.path : base);
    }
	}, fn(module, module.exports), module.exports;
}

function commonjsRequire () {
	throw new Error('Dynamic requires are not currently supported by @rollup/plugin-commonjs');
}

var _typeof_1 = createCommonjsModule(function (module) {
function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    module.exports = _typeof = function _typeof(obj) {
      return typeof obj;
    };

    module.exports["default"] = module.exports, module.exports.__esModule = true;
  } else {
    module.exports = _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };

    module.exports["default"] = module.exports, module.exports.__esModule = true;
  }

  return _typeof(obj);
}

module.exports = _typeof;
module.exports["default"] = module.exports, module.exports.__esModule = true;
});

var _typeof = /*@__PURE__*/unwrapExports(_typeof_1);

var dispatchNotification = function dispatchNotification(_a) {
  var title = _a.title,
      message = _a.message,
      timeout = _a.timeout,
      onClick = _a.onClick,
      onShow = _a.onShow,
      onError = _a.onError,
      onClose = _a.onClose,
      applicationIconPath = _a.applicationIconPath,
      additionalTag = _a.additionalTag;

  var _b = React.useState(false),
      hasAccess = _b[0],
      determineUsage = _b[1];

  var time;

  if (typeof timeout === 'number') {
    time = timeout;
  } else if (typeof timeout === 'string') {
    if (timeout.endsWith('s')) {
      time = parseInt(timeout.replace('s', ''), 2) * 1000;
    } else if (timeout.endsWith('m')) {
      time = parseInt(timeout.replace('m', ''), 2) * 60 * 1000;
    } else {
      console.warn("O campo timeout deve ser do tipo string ou number, por\xE9m est\xE1 recebendo o tipo " + _typeof(timeout));
    }
  }

  React.useEffect(function () {
    if (window) {
      if (!('Notification' in window)) {
        if (process.env.NODE_ENV !== 'production') {
          console.warn('Esse navegador suporta o uso de notificações. Logo, não será possível utilizar o hook dispatchNotification.');
        }
      } else if (Notification.permission === 'granted') {
        determineUsage(true);
      } else {
        Notification.requestPermission().then(function (permission) {
          if (permission && permission === 'granted') {
            determineUsage(true);
          }
        });
      }
    }
  }, []);
  React.useEffect(function () {
    if (hasAccess) {
      var options = {
        lang: 'pt-BR'
      };

      if (message) {
        options.body = message;
      }

      if (additionalTag) {
        options.tag = additionalTag;
      }

      if (applicationIconPath) {
        if (applicationIconPath.endsWith('.jpg') || applicationIconPath.endsWith('.svg') || applicationIconPath.endsWith('.png')) {
          options.icon = applicationIconPath;
        }
      }

      var notification_1 = new Notification(title, options);

      if (onClick) {
        notification_1.onclick = onClick;
      }

      if (onShow) {
        notification_1.onshow = onShow;
      }

      if (onError) {
        notification_1.onerror = onError;
      }

      if (onClose) {
        notification_1.onclose = onClose;
      }

      setTimeout(function () {
        notification_1.close.bind(notification_1);
      }, time);
    }
  }, [hasAccess]);
  return hasAccess;
};

var useClickAway = function useClickAway(onClick, reference) {
  var dispatcher = React.useRef(onClick);

  var onMouseDown = function onMouseDown(event) {
    if (dispatcher && dispatcher.current) {
      if (typeof dispatcher.current === 'function') {
        dispatcher.current(event);
      }
    }
  };

  var onTouchStart = function onTouchStart(event) {
    if (dispatcher && dispatcher.current) {
      if (typeof dispatcher.current === 'function') {
        dispatcher.current(event);
      }
    }
  };

  React.useEffect(function () {
    if (dispatcher && dispatcher.current) {
      if (dispatcher.current !== onClick) {
        dispatcher.current = onClick;
      }
    }
  }, [onClick]);
  React.useEffect(function () {
    document.addEventListener('mousedown', onMouseDown);
    document.addEventListener('touchstart', onTouchStart);
    return function () {
      document.removeEventListener('mousedown', onMouseDown);
      document.removeEventListener('touchstart', onTouchStart);
    };
  }, [reference]);
};

var toggleSelection = function () {
  var selection = document.getSelection();
  if (!selection.rangeCount) {
    return function () {};
  }
  var active = document.activeElement;

  var ranges = [];
  for (var i = 0; i < selection.rangeCount; i++) {
    ranges.push(selection.getRangeAt(i));
  }

  switch (active.tagName.toUpperCase()) { // .toUpperCase handles XHTML
    case 'INPUT':
    case 'TEXTAREA':
      active.blur();
      break;

    default:
      active = null;
      break;
  }

  selection.removeAllRanges();
  return function () {
    selection.type === 'Caret' &&
    selection.removeAllRanges();

    if (!selection.rangeCount) {
      ranges.forEach(function(range) {
        selection.addRange(range);
      });
    }

    active &&
    active.focus();
  };
};

var clipboardToIE11Formatting = {
  "text/plain": "Text",
  "text/html": "Url",
  "default": "Text"
};

var defaultMessage = "Copy to clipboard: #{key}, Enter";

function format(message) {
  var copyKey = (/mac os x/i.test(navigator.userAgent) ? "⌘" : "Ctrl") + "+C";
  return message.replace(/#{\s*key\s*}/g, copyKey);
}

function copy(text, options) {
  var debug,
    message,
    reselectPrevious,
    range,
    selection,
    mark,
    success = false;
  if (!options) {
    options = {};
  }
  debug = options.debug || false;
  try {
    reselectPrevious = toggleSelection();

    range = document.createRange();
    selection = document.getSelection();

    mark = document.createElement("span");
    mark.textContent = text;
    // reset user styles for span element
    mark.style.all = "unset";
    // prevents scrolling to the end of the page
    mark.style.position = "fixed";
    mark.style.top = 0;
    mark.style.clip = "rect(0, 0, 0, 0)";
    // used to preserve spaces and line breaks
    mark.style.whiteSpace = "pre";
    // do not inherit user-select (it may be `none`)
    mark.style.webkitUserSelect = "text";
    mark.style.MozUserSelect = "text";
    mark.style.msUserSelect = "text";
    mark.style.userSelect = "text";
    mark.addEventListener("copy", function(e) {
      e.stopPropagation();
      if (options.format) {
        e.preventDefault();
        if (typeof e.clipboardData === "undefined") { // IE 11
          debug && console.warn("unable to use e.clipboardData");
          debug && console.warn("trying IE specific stuff");
          window.clipboardData.clearData();
          var format = clipboardToIE11Formatting[options.format] || clipboardToIE11Formatting["default"];
          window.clipboardData.setData(format, text);
        } else { // all other browsers
          e.clipboardData.clearData();
          e.clipboardData.setData(options.format, text);
        }
      }
      if (options.onCopy) {
        e.preventDefault();
        options.onCopy(e.clipboardData);
      }
    });

    document.body.appendChild(mark);

    range.selectNodeContents(mark);
    selection.addRange(range);

    var successful = document.execCommand("copy");
    if (!successful) {
      throw new Error("copy command was unsuccessful");
    }
    success = true;
  } catch (err) {
    debug && console.error("unable to copy using execCommand: ", err);
    debug && console.warn("trying IE specific stuff");
    try {
      window.clipboardData.setData(options.format || "text", text);
      options.onCopy && options.onCopy(window.clipboardData);
      success = true;
    } catch (err) {
      debug && console.error("unable to copy using clipboardData: ", err);
      debug && console.error("falling back to prompt");
      message = format("message" in options ? options.message : defaultMessage);
      window.prompt(message, text);
    }
  } finally {
    if (selection) {
      if (typeof selection.removeRange == "function") {
        selection.removeRange(range);
      } else {
        selection.removeAllRanges();
      }
    }

    if (mark) {
      document.body.removeChild(mark);
    }
    reselectPrevious();
  }

  return success;
}

var copyToClipboard = copy;

var useClipboard = function useClipboard(timeout) {
  var _a = React.useState(),
      current = _a[0],
      copyIntoState = _a[1];

  var dispatchCopy = React.useCallback(function (value) {
    if (typeof value !== 'undefined') {
      if (typeof value === 'string') {
        copyToClipboard(value);
        copyIntoState(value);
      } else if (typeof value === 'number') {
        copyToClipboard(value.toString());
        copyIntoState(value);
      } else {
        if (typeof current !== 'undefined') {
          copyIntoState(undefined);
        }

        if (process.env.NODE_ENV !== 'production') {
          console.warn("N\xE3o foi poss\xEDvel copiar (via useClipboard) " + "o valor recebido pois tal valor \xE9 do tipo " + ("" + _typeof(value)));
        }
      }
    }
  }, []);
  React.useEffect(function () {
    var time;

    if (typeof timeout === 'number') {
      time = timeout;
    } else if (typeof timeout === 'string') {
      if (timeout.endsWith('s')) {
        time = parseInt(timeout.replace('s', ''), 2) * 1000;
      } else if (timeout.endsWith('m')) {
        time = parseInt(timeout.replace('m', ''), 2) * 60 * 1000;
      } else {
        time = parseInt(timeout, 2);
      }
    }

    if (current && time) {
      setTimeout(function () {
        return copyIntoState(undefined);
      }, time);
    }
  }, [current]);
  return [current, dispatchCopy];
};

var useDocumentTitle = function useDocumentTitle(title, backOnFinish) {
  var currentTitle = React.useRef(document.title);

  if (document) {
    if (document.title && document.title.toLowerCase() === title.toLowerCase()) {
      return;
    }
  }

  React.useEffect(function () {
    if (!document) {
      return;
    }

    document.title = title;

    if (!backOnFinish) {
      if (currentTitle && currentTitle.current) {
        if (typeof currentTitle.current === 'string') {
          document.title = currentTitle.current;
        }
      }
    }
  }, []);
};

var useOnlineOrOfflineBrowser = function useOnlineOrOfflineBrowser(option) {
  var defaultOption = option || 'keep-latest';

  var _a = React.useState(option && defaultOption === 'use-offline-as-default' ? 'offline' : 'online'),
      currentStatus = _a[0],
      updateStatus = _a[1];

  var onOnline = function onOnline() {
    return updateStatus('online');
  };

  var onOffline = function onOffline() {
    return updateStatus('offline');
  };

  React.useEffect(function () {
    if (!window) {
      return undefined;
    }

    window.addEventListener('online', onOnline);
    window.addEventListener('offline', onOffline);

    if (!(defaultOption && defaultOption === 'ignore-backup')) {
      return undefined;
    }

    return function () {
      window.removeEventListener('online', onOnline);
      window.removeEventListener('offline', onOffline);
    };
  }, []);
  return currentStatus;
};

var useScroll = function useScroll(_a) {
  var domElementID = _a.domElementID,
      dependencies = _a.dependencies,
      fallback = _a.fallback;
  var element = document.querySelector("#" + domElementID);

  var _b = React.useState(),
      hooks = _b[0],
      indicateHooks = _b[1];

  var asReference = React.useRef(element);

  var watchDependencies = function watchDependencies() {
    if (dependencies) {
      if (typeof dependencies.length === 'number' && dependencies.length === 1) {
        var trigger = dependencies[0];

        if (typeof trigger === 'string' && ['onmount', 'onstart'].includes(trigger.toLowerCase())) {
          indicateHooks([]);
        }
      } else if (!Array.isArray(dependencies)) {
        indicateHooks([dependencies]);
      }
    } else {
      indicateHooks([element]);
    }
  };

  React.useEffect(function () {
    watchDependencies();
  }, []);
  React.useEffect(function () {
    if (element && (window === null || window === void 0 ? void 0 : window.scrollTo) && asReference && asReference.current) {
      window.scrollTo({
        left: 0,
        top: asReference.current.offsetTop
      });
    } else if (fallback && typeof fallback === 'function') {
      fallback();
    } else {
      console.warn('Algo ocorreu durante a execução do trigger ' + 'do useScroll.O elemento ou sua referência precisam ' + 'de dados concretos porém algum deles recebeu valor ' + 'undefined.');
      console.warn('Mensagem acima disparada pois nenhuma função de "fallback" foi declarada.');
    }
  }, [hooks]);
};

var useWindowSize = function useWindowSize(param) {
  var isClient = typeof window !== 'undefined';

  var getSize = function getSize() {
    if (!isClient) {
      if (param === null || param === void 0 ? void 0 : param.defaultResultOrNull) {
        var _a = param.defaultResultOrNull,
            _b = _a.width,
            width = _b === void 0 ? 0 : _b,
            _c = _a.height,
            height = _c === void 0 ? 0 : _c;
        return {
          width: width,
          height: height
        };
      }

      return {
        width: 0,
        height: 0
      };
    }

    return {
      width: window.innerWidth,
      height: window.innerHeight
    };
  };

  var _a = React__default.useState(getSize()),
      windowSize = _a[0],
      setWindowSize = _a[1];

  React__default.useEffect(function () {
    if (!isClient) {
      return function () {};
    }

    var handleResize = function handleResize() {
      setWindowSize(getSize());
    };

    window.addEventListener('resize', handleResize);
    return function () {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  return windowSize;
};

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

var usePathname = function usePathname(_a) {
  var router = _a.router;

  var _b = React__default.useState({
    pathname: ''
  }),
      dynamicInfo = _b[0],
      updateDynamicInfo = _b[1];

  React__default.useEffect(function () {
    if (router && router.pathname && router.pathname.length) {
      var pathname = router.pathname;
      var slices = pathname.substr(1, pathname.length).split('/');
      var path_1 = '';
      slices.forEach(function (element, index) {
        if (index === 0) {
          path_1 += element;
        } else {
          path_1 += element.charAt(0).toUpperCase() + element.slice(1, element.length);
        }

        return path_1;
      });
      updateDynamicInfo(function (previous) {
        return __assign(__assign({}, previous), {
          pathname: path_1
        });
      });
    }
  }, [router]);
  return dynamicInfo.pathname;
};

var useLatest = function useLatest(value) {
  var ref = React.useRef(value);
  ref.current = value;
  return ref;
};

var usePrevious = function usePrevious(value, initialValue) {
  var ref = React.useRef(initialValue);
  React.useEffect(function () {
    ref.current = value;
  }, [value]);
  return ref.current;
};

var useIsomorphicLayoutEffect = typeof document !== 'undefined' ? React.useLayoutEffect : React.useEffect;

export { dispatchNotification, useClickAway, useClipboard, useDocumentTitle, useIsomorphicLayoutEffect, useLatest, useOnlineOrOfflineBrowser, usePathname, usePrevious, useScroll, useWindowSize };
